import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusTopRight12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconRadiusTopRight12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.996 8.756v-3.24a3.5 3.5 0 0 0-3.5-3.5H3.132a.5.5 0 0 1 0-1h3.364a4.5 4.5 0 0 1 4.5 4.5v3.24a.5.5 0 1 1-1 0M2.301 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6 10.928a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2.974-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-5.199.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusTopRight12);
